<template>
    <div class="prd-slid-content">
        <v-row>
            <v-col cols="12" lg="6" class="prd-img d-flex justify-center justify-lg-end">
                <router-link :to="link" class="prd-main-img">
                    <img :src="mainImage" alt="" class="d-block"/>
                    <div class="plus-wrap">
                        <span class="plus plus--white plus--lg"></span>
                    </div>
                </router-link>
                <div class="d-flex flex-column justify-center py-2 py-lg-4 h-100">
                    <div class="py-2 py-lg-6 h-20" v-if="slideImage1">
                        <img :src="slideImage1" alt="" class="d-block h-100">
                    </div>
                    <div class="py-2 py-lg-6 h-20" v-if="slideImage2">
                        <img :src="slideImage2" alt="" class="d-block h-100">
                    </div>
                    <div class="py-2 py-lg-6 h-20" v-if="slideImage3">
                        <img :src="slideImage3" alt="" class="d-block h-100">
                    </div>
                    <div class="py-2 py-lg-6 h-20" v-if="slideImage4">
                        <img :src="slideImage4" alt="" class="d-block h-100">
                    </div>
                    <div class="py-2 py-lg-6 h-20" v-if="slideImage5">
                        <img :src="slideImage5" alt="" class="d-block h-100">
                    </div>
                </div>
            </v-col>
        </v-row>
        <div class="prd-txt-box-wrap">
            <div class="prd-txt-box color-white">
                <h5>
                    {{tit}}
                </h5>
                <p>
                    <slot/>
                </p>
            </div>
        </div>
    </div>
</template>

<script>

export default{
    props : {
        link : {type :String, default : ""},
        mainImage : {type :String, default : ""},
        slideImage1 : {type :String, default : ""},
        slideImage2 : {type :String, default : ""},
        slideImage3 : {type :String, default : ""},
        slideImage4 : {type :String, default : ""},
        slideImage5 : {type :String, default : ""},
        tit : {type :String, default : ""},
    },
    components: {
    },
    data: () => {
        return {
        }
    },
	created() {
	},
	// mounted() {
	// 	this.init();
	// },
	// methods : {
	// 	init : function() {
    //         setTimeout(() => {
    //             AOS.init({
    //                 once: false,
    //                 offset: 240,
    //                 duration: 500,
    //                 throttleDelay : 100,
    //                 easing : 'ease-in-out',
    //                 anchorPlacement : 'top-center',
    //             });
    //         }, 100);
	// 	}
	// },
}
</script>

<style scoped>

</style>